class Header {
    constructor(header) {
        if (!header) return;

        this.header = header;

        this.init();
    }

    init() {
        this.registerEvents();
        // this.clock();
    }

    registerEvents() {
        const headerPixel = document.querySelector('#main-header-pixel');
        this.intersectionObserver().observe(headerPixel);
    }

    clock() {
        const clock = this.header.querySelector('.main-header__clock');

        const today = new Date();
        const h = today.getHours();
        let m = today.getMinutes();
        m = m < 10 ? '0' + m : m;
        clock.innerHTML = h + ':' + m;

        setTimeout(function() {
            this.clock();
        }.bind(this), 1000);
    }

    intersectionObserver() {
        return new IntersectionObserver((entries) => {
            if (entries[0].boundingClientRect.y < 0) {
                this.setState('is', 'scrolled');
            } else {
                this.removeState('is', 'scrolled');
            }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
        });
    }

    setState(type, state) {
        const cssClass = `${type}-${state}`;

        this.header.classList.add(cssClass);
    }

    removeState(type, state) {
        const cssClass = `${type}-${state}`;

        this.header.classList.remove(cssClass);
    }
}

new Header(document.querySelector('.main-header'));
